module.exports = __webpack_public_path__ + "static/media/stykala-logo.97cb4613.svg";